import "./App.css";
import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MostBooked from "./components/MostBooked";
import Banners from "./components/Banners";
import ServicesSection from "./components/ServicesSection";
import PopularServices from "./components/PopularServices";
import WhyChoose from "./components/WhyChoose";
import Testimonials from "./components/Testimonials";
import TopBeauticians from "./components/TopBeauticians";
import Blog from "./components/Blog";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CartDrawer from "./components/CartDrawer";
import FloatingCheckout from "./components/FloatingCheckout";
import Admin from "./components/Admin";
import Account from "./components/Account";
import AuthCallback from "./components/AuthCallback";
import PageView from "./components/PageView";
import { BlogList, BlogDetail } from "./components/BlogPage";
import PackagesPage from "./components/PackagesPage";
import OffersPage from "./components/OffersPage";
import ServicesPage from "./components/ServicesPage";
import Contact from "./components/Contact";
import BecomeBeautician from "./components/BecomeBeautician";
import Invoice from "./components/Invoice";

const Home = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Banners />
        <ServicesSection />
        <MostBooked />
        <PopularServices selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
        <WhyChoose />
        <Testimonials />
        <TopBeauticians />
        <Blog />
        <CTABanner />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CartDrawer />
    </>
  );
};

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback FIRST (synchronously during render) to avoid race conditions
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/account" element={<Account />} />
      <Route path="/packages" element={<PackagesPage />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:cat" element={<ServicesPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/become-beautician" element={<BecomeBeautician />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogDetail />} />
      <Route path="/page/:slug" element={<PageView />} />
      <Route path="/invoice/:id" element={<Invoice />} />
      <Route path="/:catSlug" element={<ServicesPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <FloatingCheckout />
          <Toaster />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
